import './error-page.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorHandler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      error: null,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      error,
      hasError: true,
    });
  }

  refreshSite = () => {
    window.location.reload();
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className='error-page'>
          <div>
            <h2 className='text-center'>Error Page</h2>
            <p>An unexpected error has occurred.</p>

            {error.name === 'ChunkLoadError' && (
              <>
                <p>
                  This application has been updated, please refresh this page to load the latest app version.
                </p>

                <button
                  type='button'
                  className='btn btn--yellow btn--size-md'
                  onClick={this.refreshSite}
                >
                  Refresh site
                </button>
              </>
            )}
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorHandler.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorHandler;
